import { render, staticRenderFns } from "./detail_index.vue?vue&type=template&id=57fe20df"
import script from "./detail_index.vue?vue&type=script&lang=js"
export * from "./detail_index.vue?vue&type=script&lang=js"
import style0 from "./detail_index.vue?vue&type=style&index=0&id=57fe20df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports